<template>
    <div>
        <Header
        title="Add your own offer"
        icon="CirclePlus"
        />
        <div class="bg-white rounded-xl shadow-lg mb-[20px]">
            <div class="grid grid-cols-5 w-full">
                <div
                    class="bg-pink-500 text-sm col-span-2 text-white border-b-2 rounded-tl-xl flex items-top justify-center p-1">
                    <LucideIcon name="Store" :size="18" :stroke-width="1.7" />
                    <p class="pl-2 font-semibold">Retailer</p>
                </div>
                <div
                    class="bg-blue-500 text-sm col-span-1 text-white border-b-2  flex justify-center items-top justify-center p-1">
                    <LucideIcon name="Antenna" :size="18" :stroke-width="1.7" />
                    <p class="pl-2 font-semibold">MIDs</p>
                </div>
                <div
                    class="bg-violet-500 text-sm col-span-2 text-white border-b-2 rounded-tr-xl flex justify-center items-top justify-center p-1">
                    <LucideIcon name="BadgePercent" :size="18" :stroke-width="1.7" />
                    <p class="pl-2 font-semibold">Offers</p>
                </div>
                <div class="bg-white border-b-2  flex justify-start" @click="selectedPage = 'RETAILER'"
                    :class="selectedPage == 'RETAILER' ? 'text-[#302E81] cursor-pointer' : 'opacity-100 cursor-pointer'">
                    <div class="flex justify-start items-center ">
                        <div class="w-6 ml-3 h-6 rounded-md ">
                            <LucideIcon :name="logo['RETAILER']" :size="26" :stroke-width="1.7" />
                        </div>
                        <div class="ml-3">
                            <p class="text-xs " :class="selectedPage == 'RETAILER' ? 'font-semibold' : 'font-medium'">
                                Select or create retailer</p>
                            <p class="text-[9px] " :class="selectedPage == 'RETAILER' ? 'font-medium' : ''">Select or
                                create a new retailer profile</p>
                        </div>
                    </div>
                </div>
                <div class="bg-white border-b-2 flex justify-start"
                    @click="validateRetailer ? selectedPage = 'TRANSACTION' : ''"
                    :class="selectedPage == 'TRANSACTION' ? 'text-[#302E81]' : validateRetailer ? 'opacity-100 cursor-pointer' : 'opacity-60 cursor-not-allowed'">
                    <div>
                        <img src="@/assets/tabArrow.svg" />
                    </div>
                    <div class="flex justify-start items-center ">
                        <div class="w-6 ml-3 h-6 rounded-md ">
                            <LucideIcon :name="logo['TRANSACTION']" :size="26" :stroke-width="1.7" />
                        </div>

                        <div class="ml-3">
                            <p class="text-xs" :class="selectedPage == 'TRANSACTION' ? 'font-semibold' : 'font-medium'">
                                Transaction compatibility</p>
                            <p class="text-[9px] " :class="selectedPage == 'TRANSACTION' ? 'font-medium' : ''">Is this
                                offer
                                avaliable to OB publishers</p>
                        </div>
                    </div>

                </div>

                <div class="bg-white border-b-2  flex justify-start"
                    @click="validateTransaction ? selectedPage = 'CHANNEL' : ''"
                    :class="selectedPage == 'CHANNEL' ? 'text-[#302E81]' : validateTransaction ? 'opacity-100 cursor-pointer' : 'opacity-60 cursor-not-allowed'">
                    <div>
                        <img src="@/assets/tabArrow.svg" />
                    </div>
                    <div class="flex justify-start items-center ">
                        <div class="w-6 ml-3 h-6 rounded-md ">
                            <LucideIcon :name="logo['CHANNEL']" :size="26" :stroke-width="1.7" />
                        </div>
                        <div class="ml-3">
                            <p class="text-xs" :class="selectedPage == 'CHANNEL' ? 'font-semibold' : 'font-medium'">
                                Add
                                MIDs</p>
                            <p class="text-[9px] " :class="selectedPage == 'CHANNEL' ? 'font-medium' : ''">Define the
                                relevant
                                MIDs</p>
                        </div>
                    </div>
                </div>
                <div class="bg-white border-b-2 rounded-tl-xl flex justify-start"
                    @click="validateChannels && validateTransaction ? selectedPage = 'OFFERINFORMATION' : ''"
                    :class="selectedPage == 'OFFERINFORMATION' ? 'text-[#302E81]' : validateChannels && validateTransaction ? 'opacity-100 cursor-pointer' : 'opacity-60 cursor-not-allowed'">
                    <div>
                        <img src="@/assets/tabArrow.svg" />
                    </div>
                    <div class="flex justify-start items-center ">
                        <div class="w-6 ml-3 h-6 rounded-md ">
                            <LucideIcon :name="logo['OFFERINFORMATION']" :size="26" :stroke-width="1.7" />
                        </div>
                        <div class="ml-3">
                            <p class="text-xs "
                                :class="selectedPage == 'OFFERINFORMATION' ? 'font-semibold' : 'font-medium'">
                                Supplier & display info</p>
                            <p class="text-[9px] " :class="selectedPage == 'OFFERINFORMATION' ? 'font-medium' : ''">Add
                                name,
                                logo
                                and description</p>
                        </div>
                    </div>

                </div>


                <div class="bg-white  border-b-2 rounded-tr-xl flex justify-start"
                    @click="validateOfferInformation ? selectedPage = 'OFFER' : ''"
                    :class="selectedPage == 'OFFER' ? 'text-[#302E81]' : validateOfferInformation ? 'opacity-100 cursor-pointer' : 'opacity-60 cursor-not-allowed'">
                    <div>
                        <img src="@/assets/tabArrow.svg" />
                    </div>
                    <div class="flex justify-start items-center ">
                        <div class="w-6 ml-3 h-6 rounded-md ">
                            <LucideIcon :name="logo['OFFER']" :size="26" :stroke-width="1.7" />
                        </div>
                        <div class="ml-3 mr-1">
                            <p class="text-xs" :class="selectedPage == 'OFFER' ? 'font-semibold' : 'font-medium'">Create
                                cashback rules</p>
                            <p class="text-[9px] " :class="selectedPage == 'OFFER' ? 'font-semibold' : 'font-medium'">
                                Create the
                                cashback rules</p>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <div v-if="retailerData.retailerName != ''" class="bg-gray-50 flex justify-start items-center px-3 py-2 gap-2 w-full border-t border-b border-gray-300">
                <img class="object-contain w-[36px] h-[36px] border border-gray-200 bg-white rounded-lg"
                    :src="retailerData.retailerLogo" />
                <div class="">
                    <p class="font-medium text-normal">{{ retailerData.retailerName }}</p>
                </div>
            </div>
            <div class="min-h-[300px] px-4">
                <div class="mt-3 m-2">
                    <p class="text-md font-medium mb-1">{{ titles[selectedPage] }}</p>
                    <hr>
                </div>
                <Retailer :retailData="retailerData" v-if="selectedPage == 'RETAILER'"
                    @formSubmitSelect="retailerSelected" @formSubmitCreated="retailerCreated"></Retailer>
                <Channel v-if="selectedPage == 'CHANNEL'" :retailerData="retailerData" @formSubmit="channelSubmission">
                </Channel>
                <Transaction v-if="selectedPage == 'TRANSACTION'" :retailerData="retailerData"
                    @formSubmit="transactionSubmission"></Transaction>
                <OfferInformation v-if="selectedPage == 'OFFERINFORMATION'" :offerInformationData="offerInformation"
                    :retailerData="retailerData" @formSubmit='offerInformationSubmit'></OfferInformation>
                <Offer @offerCashbackSumbit="submitCashback" :retailerData="retailerData"
                    :offerInformationData="offerInformation" v-if="selectedPage == 'OFFER'"></Offer>



            </div>
            <div class="flex rounded-md justify-end m-2 ">
                <div class="flex rounded-md text-gray-600 justify-between bg-gray-100 mx-2 my-6 p-2 items-center w-1/3">
                    <div class="ml-3 mr-1">
                        <p class="text-xs font-medium">Next stage</p>
                        <p class="text-xs font-semibold">{{ nextStep[selectedPage] }} </p>
                    </div>
                    <div class="ml-3 mr-1">
                        <CustomButton
                            :text="selectedPage == 'TRANSACTION' ? 'Create retailer' : selectedPage == 'OFFER' ? 'Create offer' : 'Next step'"
                            :disabled="!validForm" type="navigate" icon="MoveRight" @click="navigate()" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import LucideIcon from "@/components/LucideIcon.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import Transaction from "@/components/offer/Transaction.vue";
import OfferInformation from "@/components/offer/OfferInformation.vue";
import Retailer from "@/components/offer/Retailer.vue"
import Channel from "@/components/offer/Channel.vue";
import Offer from "@/components/offer/Offer.vue";



export default {
    name: "add-offers",
    components: {
        Header,
        LucideIcon,
        CustomButton,
        Transaction,
        OfferInformation,
        Channel,
        Offer,
        Retailer

    },
    props: {
    },
    data() {
        return {
            activateOfferRequest:{
                splitOfCashbackPercentage:{
                    endUser:50,
                    client:50
                },
                activate:true
            },

            selectedPage: "RETAILER", //TRANSACTION,RETAILER,CHANNEL,OFFERINFORMATION,OFFER
            selectedRetailer: false,
            nextStep: {
                "RETAILER": "Transaction compatibility",
                "TRANSACTION": "Add MIDs",
                "CHANNEL": "Offer information",
                "OFFERINFORMATION": "Create rules",
                "OFFER": "View offer"
            },
            titles: {
                "RETAILER": "1. Create or select a retailer",
                "TRANSACTION": "2. Verify brand compatability with Boogi's transaction matching engine",
                "CHANNEL": "3. Add the relevant MIDs",
                "OFFERINFORMATION": "4. Create the offers information",
                "OFFER": "5. Cashback rules",
                "SUBMISSION": "6. Review and submit",

            },
            logo: {
                "TRANSACTION": "Circle",
                "RETAILER": "Circle",
                "CHANNEL": "Circle",
                "OFFERINFORMATION": "Circle",
                "OFFER": "Circle",
            },
            retailerData: {
                id: "",
                retailerName: "",
                retailerWebsite: "",
                retailerLogoFile: undefined,
                retailerLogo: "",
                obCompatiable: undefined,
                monthlyWebVisits:undefined,
                goodForBusiness:undefined,
                luxury:undefined,
                subscription:undefined,

            },
            channelsExist: true,
            enirchmentCompatiable: undefined,
            offerInformation: {
                supplierName: "",
                supplierId: "",
                offerLogo: "",
                offerLogoFile: undefined,
                offerDescription: "",
                lengthOfTime:undefined,
                currency: "",
                country: "",
                offerName: "",
                categories:[],
                link: "",
                offerType: "",
                approval: "",
                hidden: "",
                matchAgainst: "",
                channels: [],
                cashbackRules: [
                    {
                        customerType: "",
                        lapsedInDays: null,
                        conditions: [
                            {
                                type: "",
                                lowerBound: null,
                                upperBound: null,
                                value: {
                                    type: "",
                                    totalValue: undefined,
                                    maxAvailableValue: undefined,
                                    maximum: undefined,
                                    endUserValue: undefined,
                                    supplierValue: 0,
                                    boogiValue: 0,
                                    clientValue: undefined
                                },
                                fixedDistributorCommission: true
                            }
                        ]
                    }
                ]
            }
        }
    },
    methods: {
        offerInformationSubmit(data) {
            this.offerInformation = data
            this.logo["OFFERINFORMATION"] = "CircleCheck"
        },

        transactionSubmission(data) {
            this.enirchmentCompatiable = data
            this.logo["TRANSACTION"] = "CircleCheck"
        },

        submitCashback(data) {
            this.offerInformation.cashbackRules = data.cashbackRules
            this.logo["OFFER"] = "CircleCheck"

        },

        async createRetailer() {
            var retailerRequest = {
                retailerName: this.retailerData.retailerName,
                retailerOpenBankingDescription: this.enirchmentCompatiable.description,
                providedLogo: "https://placehold.co/32x32",
                providedWebsite: this.retailerData.retailerWebsite,
                obPublisherCompatible: this.enirchmentCompatiable.enrichmentCompatiable,
                monthlyWebVisits:this.retailerData.monthlyWebVisits,
                goodForBusiness:this.retailerData.goodForBusiness,
                luxury:this.retailerData.luxury,
                subscription:this.retailerData.subscription,
            }

            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer`, {
                    method: "POST",
                    body: JSON.stringify(retailerRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var data = await response.json()
                    this.retailerData.id = data.retailer.id
                    this.retailerData.retailerName = data.retailer.retailerName
                    this.retailerData.retailerWebsite = data.retailer.retailerWebsite
                    this.retailerData.retailerLogo = data.retailer.logo
                    this.retailerData.monthlyWebVisits = data.retailer.monthlyWebVisits
                    this.retailerData.goodForBusiness = data.retailer.goodForBusiness
                    this.retailerData.luxury = data.retailer.luxury
                    this.retailerData.subscription = data.retailer.subscription

                    if (this.retailerData.obCompatiable) {
                        this.uploadLogoImage(data)
                    }


                }

            } catch (error) {
                return;
            }
        },

        async uploadRetailerLogoImage(data) {
            try {

                const formData = new FormData();
                formData.append('multipartFile', this.retailerRequestData.retailerLogoFile);

                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer/upload-image/${data.retailer.id}`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var dataResponse = await response.json()
                    this.retailerData.retailerLogo = dataResponse.retailer.logo
                    this.selectedPage = "CHANNEL"
                }
            } catch (error) {
                return;
            }

        },

        async uploadOfferLogoImage(data) {
            try {

                const formData = new FormData();
                formData.append('multipartFile', this.offerInformation.offerLogoFile);

                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/offer/upload-image/${data.id}`, {
                    method: "POST",
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.requestApproval(data)
                }
            } catch (error) {
                console.error(error)
                return;
            }

        },

        async requestApproval(data){
            try {
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')
                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/apply/${data.id}`, {
                    method: "POST",
                    body:JSON.stringify(this.activateOfferRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.loading = false
                    this.$router.push(`/retailer/${data.retailer.id}/offer/${data.id}`)                    
                }

            } catch (error) {
                console.log(error)
                return;
            }
        },

        async createOffer() {
            var body = {
                offerName: this.offerInformation.offerName,
                retailerId: this.retailerData.id,
                offerType: this.offerInformation.offerType,
                supplierOffersId: [this.offerInformation.supplierId],
                offerValidFor: this.offerInformation.matchAgainst,
                channelIds: this.offerInformation.channels,
                lengthOfTime:this.offerInformation.lengthOfTime,
                cashbackRules: this.offerInformation.cashbackRules,
                country: this.offerInformation.country,
                currency: this.offerInformation.currency,
                displayInformation: {
                    retailerName: this.retailerData.retailerName,
                    logo: "https://placeholder.co/32x32",
                    description: this.offerInformation.offerDescription,
                    categories: this.offerInformation.categories,
                    termsAndConditions: null,
                    banner: null,
                    link: this.offerInformation.link
                }
            }

            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/offer`, {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var data = await response.json()
                    this.uploadOfferLogoImage(data)
                }

            } catch (error) {
                return;
            }


        },


        retailerSelected(data) {
            this.logo["RETAILER"] = "CircleCheck"
            this.logo["TRANSACTION"] = "CircleCheck"
            this.nextStep["RETAILER"] = 'Create channels'

            this.retailerData.id = data.id
            this.retailerData.retailerName = data.retailerName
            this.retailerData.retailerWebsite = data.retailerWebsite
            this.retailerData.retailerLogo = data.logo
            this.retailerData.monthlyWebVisits = data.monthlyWebVisits
            this.retailerData.goodForBusiness = data.goodForBusiness
            this.retailerData.luxury = data.luxury
            this.retailerData.subscription = data.subscription

            
            this.retailerData.obCompatiable = data.openBankingPublisherCompatible

            this.selectedRetailer = true

        },

        retailerCreated(data) {
            this.logo["RETAILER"] = "CircleCheck"
            this.logo["TRANSACTION"] = "Circle"
            this.nextStep["RETAILER"] = 'Transaction compatability'


            this.retailerData.retailerName = data.retailerName
            this.retailerData.retailerWebsite = data.retailerWebsite
            this.retailerData.retailerLogo = data.displayUrl
            this.retailerData.retailerLogoFile = data.retailerLogoFile
            this.retailerData.monthlyWebVisits = data.monthlyWebVisits
            this.retailerData.goodForBusiness = data.goodForBusiness
            this.retailerData.luxury = data.luxury
            this.retailerData.subscription = data.subscription

            this.selectedRetailer = false

        },

        channelSubmission() {
                this.logo["CHANNEL"] = "CircleCheck"

        },

        navigate() {
            if (this.selectedPage == 'RETAILER') {
                if (this.selectedRetailer) {
                    return this.selectedPage = "CHANNEL"
                }
                else {
                    return this.selectedPage = "TRANSACTION"
                }
            }

            if (this.selectedPage == 'TRANSACTION') {
                this.createRetailer()
            }

            if (this.selectedPage == 'CHANNEL') {
                return this.selectedPage = "OFFERINFORMATION"
            }

            if (this.selectedPage == 'OFFERINFORMATION') {
                return this.selectedPage = "OFFER"
            }

            if (this.selectedPage == 'OFFER') {
                this.createOffer()
                //TODO create cashback
            }

        },

  
    },
    computed: {
        validForm() {
            if (this.selectedPage == 'RETAILER') {
                return this.validateRetailer
            }
            else if (this.selectedPage == 'TRANSACTION') {
                return this.validateTransaction
            }
            else if (this.selectedPage == 'CHANNEL') {
                return this.validateChannels
            }
            else if (this.selectedPage == 'OFFERINFORMATION') {
                return this.validateOfferInformation
            }
            else if (this.selectedPage == 'OFFER') {
                return this.validateCashback
            }

            else
                return false
        },

        validateCashback() {
            return this.offerInformation.cashbackRules[0].customerType != ""
        },


        validateRetailer() {
            return this.retailerData.retailerName != "" && this.retailerData.retailerLogoFile != undefined || this.selectedRetailer
        },

        validateChannels() {
            return this.channelsExist
        },
        validateTransaction() {
            return this.enirchmentCompatiable != undefined || this.selectedRetailer
        },
        validateOfferInformation() {
            return  this.offerInformation.supplierId != "" && this.offerInformation.offerDescription && this.offerInformation.offerLogoFile != undefined
        }

    }
}

</script>